// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__Pm5Sj","errors":"Errors_errors__1y_ZJ"};